import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface EngagementTableProps {
    engagements: Array<{
        part_name: string;
        engagement: number;
    }>
    mt: number | string;
}

const EngagementTable: React.FC<EngagementTableProps> = ({ engagements, mt }) => {
    const { t } = useTranslation('admDashboard');
    return (
        <>
            <h5 className={`mt-${mt}`}>{t('engagementTableTitle')}</h5>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>{t('product')}</th>
                        <th>{t('engagement')}</th>
                    </tr>
                </thead>
                <tbody>
                    {engagements.map((e, index) =>
                        <tr key={index}>
                            <td className="text-capitalize">{e.part_name}</td>
                            <td>{e.engagement}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default EngagementTable;
